import { ChangeDetectionStrategy, Component, forwardRef } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { ProviderShell } from '../shared/provider-shell';
import { ProviderShellLayoutComponent } from '../shared/provider-shell-layout.component';

/** Shell for provider types without a dedicated UI (/admin/providers/:providerId). */
@Component({
  selector: 'app-generic-provider-shell',
  standalone: true,
  imports: [RouterOutlet, ProviderShellLayoutComponent],
  template: `<app-provider-shell-layout><router-outlet /></app-provider-shell-layout>`,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: ProviderShell, useExisting: forwardRef(() => GenericProviderShellComponent) }],
  host: { class: 'block h-full min-h-0' },
})
export class GenericProviderShellComponent extends ProviderShell {
  readonly routeType = null;
}
